var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c('progress',_vm._b({staticClass:"progress is-tiny is-primary mb-0",attrs:{"max":"100"}},'progress',_vm.$attrs,false)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }